import { MapfreButtonComponent } from '../../../../../modules/mapfre-design-library/src/lib/_components/individual-components/inputs/mapfre-button/mapfre-button.component';
import { MapfreModalComponent } from '../../../../../modules/mapfre-design-library/src/lib/_components/section-components/mapfre-modal/mapfre-modal.component';
import { MapfreLoadingComponent } from '../../../../../modules/mapfre-design-library/src/lib/_components/individual-components/mapfre-loading/mapfre-loading.component';
import { NgSelectModule } from '@ng-select/ng-select';
import { MapfreDesignLibraryModule } from '../../../../../modules/mapfre-design-library/src/public_api';
import { TranslateModule } from '@ngx-translate/core';
import { CommonModule } from '@angular/common';
import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators , FormsModule , ReactiveFormsModule } from '@angular/forms';
import { Router , RouterModule } from '@angular/router';
import { ModalOptions } from '@mapfre-design-library/src/public_api';
import { TwoFADataService } from '@services/data-services/twoFA-data.service';
import { PhoneFormatter } from '@helpers/_formatters/phone-formatter';
import { AcmicService } from '@mapfre-design-library/src/public_api';
import { UserDataService } from '@services/data-services/user-data.service';
import { Subscription } from 'rxjs';
import { take } from 'rxjs/operators';

@Component({
  standalone: true,
  imports: [CommonModule, FormsModule, ReactiveFormsModule, RouterModule, TranslateModule, MapfreDesignLibraryModule, NgSelectModule, MapfreLoadingComponent, MapfreModalComponent, MapfreButtonComponent],
  selector: 'app-edit-two-factor-authentication',
  templateUrl: './edit-two-factor-authentication.component.html',
  styleUrls: ['./edit-two-factor-authentication.component.scss'],
})
export class EditTwoFactorAuthenticationComponent implements OnInit {
  form!: FormGroup;
  confirmationModal!: ModalOptions;
  hideModal: boolean;
  loader = false;
  isModalDisabled = true;
  isAcmic: boolean;
  countryCode = '';
  currentPhone = '';
  newPhone = '';
  mfaFactorId = '';
  oktaUserId = '';
  formattedCurrentPhone = '';
  formattedNewPhone = '';
  loading: boolean;
  clickTrakcer = 0;
  phoneObject: any = {};
  errorMsg: string;
  routerSub: Subscription;
  @ViewChild('phoneInput') phoneInput!: ElementRef<HTMLInputElement>;
  @ViewChild('extensionInput') extensionInput!: ElementRef<HTMLInputElement>;
  @ViewChild('modalRef') modalRef;

  constructor(
    private fb: FormBuilder,
    private router: Router,
    private twoFAService: TwoFADataService,
    public phoneFormatter: PhoneFormatter,
    private acmicService: AcmicService,
    private userDataService: UserDataService
  ) { }

  ngOnInit(): void {
    this.isAcmic = this.acmicService.isACMIC();

    this.confirmationModal = new ModalOptions({
      additionalClasses:
        'center-on-page modal-dialog modal-medium modal-dialog-scrollable edit-mfaPhone-modal',
      additionalButtonClasses:
        'btn mapfre basic primary edit-twoFA-confirm edit-twoFA-confirm-text',
      animatePosition: 'top',
      buttonCopy: 'Confirm',
      typeOfModal: 'address confirmation ma',
    });

    this.form = this.fb.group({
      phoneNumber: ['', [Validators.required, Validators.pattern(/^[0-9]{1,10}$/)]],
    });

    this.loadUserData();
  }

  get phoneNumber() {
    return this.form.get('phoneNumber');
  }

  get extension() {
    return this.form.get('extension');
  }

  loadUserData(): void {
    this.loading = true;
    this.userDataService.$userData.pipe(take(1)).subscribe((user) => {
      if (user && user.userDetails) {
        this.mfaFactorId = user.userDetails.mfaFactorId;
        this.oktaUserId = user.userDetails.oktaUserId;

        const fullPhone = user.userDetails.mfaPhone || '';
        const phoneDigits = fullPhone.replace('+', '');
        const phoneLength = phoneDigits.length;

        if (phoneLength > 10) {
          this.countryCode = '+' + phoneDigits.slice(0, phoneLength - 10);
          this.currentPhone = phoneDigits.slice(-10);
        } else {
          this.countryCode = '+1';
          this.currentPhone = phoneDigits;
        }

        this.formattedCurrentPhone = this.phoneFormatter.format(this.currentPhone);

        this.form.patchValue({
          phoneNumber: this.phoneFormatter.format(this.currentPhone),
        });

        this.isModalDisabled = this.currentPhone.length <= 10;
        this.loading = false;
      } else {
        this.loading = false;
      }
    });
  }

  onPhoneInput(event: any): void {
    this.errorMsg = '';
    const inputEl = event.target as HTMLInputElement;
    const rawValue = inputEl.value;

    const digitsOnly = rawValue.replace(/\D/g, '').slice(0, 10);
    let formattedValue = this.phoneFormatter.format(digitsOnly);
    formattedValue = formattedValue.replace(/-$/, '');

    const oldCursor = inputEl.selectionStart || 0;
    const digitsLeftOfCursor = rawValue.slice(0, oldCursor).replace(/\D/g, '').length;

    this.form.get('phoneNumber')?.setValue(digitsOnly, { emitEvent: false });
    inputEl.value = formattedValue;
    this.formattedNewPhone = formattedValue;

    let newCursor = formattedValue.length;
    let digitsSeen = 0;

    for (let i = 0; i < formattedValue.length; i++) {
      if (/\d/.test(formattedValue[i])) digitsSeen++;
      if (digitsSeen >= digitsLeftOfCursor) {
        newCursor = i + 1;
        break;
      }
    }

    if (digitsOnly.length >= 10 && digitsLeftOfCursor >= 10) {
      newCursor = formattedValue.length;
    }

    setTimeout(() => {
      inputEl.setSelectionRange(newCursor, newCursor);
    });

    this.isModalDisabled = digitsOnly.length >= 10;
  }


  hideModalAction(): void {
    this.hideModal = true;
  }

  resetHideModal(): void {
    this.hideModal = false;
  }

  cancelEdit(): void {
    this.router.navigate(['/profile', 'two-factor-authentication']);
  }

  onSubmit(): void {
    if (this.form.invalid) return;
    this.newPhone = this.form.value.phoneNumber.trim();
    this.hideModal = false;
  }

  triggerPhoneModal(): void {
    this.clickTrakcer++;
    if (this.clickTrakcer === 1) {
      this.createPhoneObject();
    }
    this.hideModal = false;
  }

  createPhoneObject(): void {
    const formValues = this.form.value;
    const formattedPhone = `${this.countryCode}${formValues.phoneNumber.trim()}`;

    this.phoneObject = {
      oldPhone: `${this.countryCode}${this.currentPhone}`,
      newPhone: formattedPhone,
      mfaFactorId: this.mfaFactorId,
      oktaUserId: this.oktaUserId,
    };

    this.formattedCurrentPhone = this.phoneFormatter.format(this.currentPhone);
    this.formattedNewPhone = this.phoneFormatter.format(formValues.phoneNumber.trim());
  }

  changePhone(): void {
    const phoneValue = (this.form.get('phoneNumber')?.value?.replace(/\D/g, '') || '').trim();

    if (!phoneValue) {
      console.log('Phone number missing');
      return;
    }

  const fullNewPhone = `${this.countryCode}${phoneValue}`;
  this.loader = true;

  this.twoFAService
    .updateMfaPhone(this.mfaFactorId, this.oktaUserId, fullNewPhone)
    .subscribe({
      next: () => {
        this.loader = false;
        this.currentPhone = phoneValue;
        this.formattedCurrentPhone = this.phoneFormatter.format(phoneValue);

        this.userDataService.$userData.pipe(take(1)).subscribe((user) => {
          if (user && user.userDetails) {
            const updatedUser = {
              ...user,
              userDetails: {
                ...user.userDetails,
                mfaPhone: fullNewPhone
              },
            };
            this.userDataService.updateUserDetails(updatedUser);
          }
        }).unsubscribe();

        this.router.navigate(['/profile', 'two-factor-authentication'], {
          state: { phoneUpdated: true },
        });
      },
      error: (error) => {
        console.error('Error updating phone:', error);
        this.loader = false;
        this.errorMsg = error?.error?.Message;
        this.modalRef.modal.hide();
      },
    });
  }
}